import { BaseRule } from '../BaseRule';

class RegexRule extends BaseRule {
	pattern: RegExp;

	constructor(errorMessage: string, pattern: RegExp) {
		super('regex', errorMessage);
		this.pattern = pattern;
	}

	isValidInternal = (val: string) => {
		return (
			BaseRule.isEmptyValue(val) ||
			val.toString().match(this.pattern) !== null
		);
	};
}

export default RegexRule;
